import { axios } from '@/utils/request';

const api = {
  productionLine: 'service/info/detail/production_line',
  operator: 'service/info/detail/operator',
  score: 'service/detail/score',
  info: 'service/detail/info',
  zb: 'service/detail/zb',
  zbExport: 'service/detail/zb_export',
  scoreTrend: 'service/detail/score_trend',
  taskType: 'service/info/overview/task_type',
  taskLabel: 'service/info/detail/task_label',
};

/**
 * 获取产线
 * @param params
 * @returns {AxiosPromise}
 */
export function getProductionLine(params) {
  return axios({
    url: api.productionLine,
    method: 'get',
    params,
  });
}

export function getOperator(params) {
  return axios({
    url: api.operator,
    method: 'get',
    params,
  });
}

export function getScore(params) { // 雷达图详情
  return axios({
    url: api.score,
    method: 'get',
    params,
  });
}

export function getInfo(params) {
  return axios({
    url: api.info,
    method: 'get',
    params,
  });
}

export function getTrend(params) {
  return axios({
    url: api.scoreTrend,
    method: 'get',
    params,
  });
}

/**
 * 获取综合评分时间趋势
 * @param params
 * @returns {AxiosPromise}
 */
export function getComprehensive(params) {
  return getTrend({  zb: '0', ...params });
}

/**
 * 获取评价维度时间趋势
 * @param params
 * @returns {AxiosPromise}
 */
export function getDimension(params) {
  return getTrend({ zb: '1', ...params });
}

export function getDetailZb(params) {
  return axios({
    url: api.zb,
    method: 'get',
    params,
  });
}

export function getzbExport(params) {
  return axios({
    url: api.zbExport,
    method: 'get',
    params,
  });
}

export function getTaskType(params) {
  return axios({
    url: api.taskType,
    method: 'get',
    params,
  });
}
export function getTaskLabel(params) {
  return axios({
    url: api.taskLabel,
    method: 'get',
    params,
  });
}
